const testManagerRouter = [
    {
        path:'list',
        name:'testManager-index',
        redirect: { name: 'testManager-waitTestList' },
        component: () => import(/* webpackChunkName: "about" */ '../views/testManager/index.vue'),
        children:[
            {
                path:'waitTestList',
                name:'testManager-waitTestList',
                component: () => import(/* webpackChunkName: "about" */ '../views/testManager/waitTestList.vue')
            },{
                path:'testIng',
                name:'testManager-testIng',
                component: () => import(/* webpackChunkName: "about" */ '../views/testManager/testIng.vue')
            },{
                path:'outSideTest',
                name:'testManager-outSideTest',
                component: () => import(/* webpackChunkName: "about" */ '../views/testManager/outSideTest.vue')
            },{
                path:'inSideTest',
                name:'testManager-inSideTest',
                component: () => import(/* webpackChunkName: "about" */ '../views/testManager/inSideTest.vue')
            }
        ],
    },{
        path:'apply',
        name:'testManager-apply',
        component: () => import(/* webpackChunkName: "about" */ '../views/testManager/apply.vue'),
    },{
        path:'detail/:id',
        name:'testManager-apply-detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/testManager/detail.vue')
    }
    
  ]
  export default testManagerRouter